import pillSection from 'public/pill-section.svg';
import LinkWithQuery from 'src/app/components/Elements/LinkWithQuery';
import { DefaultPhoneNumber } from 'src/app/components/Elements/Location';
import { Typography } from 'src/app/components/Elements/Typography';
import {
  about,
  blog,
  careers,
  doctors,
  external,
  hipaa,
  press,
  privacy,
  termsAndConditions,
} from 'src/app/router/paths';
import { getUrlPathWithPreservedQuery } from 'src/app/utils';
import { CAPSULE_HELP_EMAIL } from 'src/consts';

import { appStoreIcon, facebookIcon, googlePlayIcon, instagramIcon, twitterIcon } from './icons';
import {
  AppButtonsContent,
  CompanyInfoContent,
  Copyright,
  CopyrightLink,
  FlexContent,
  Info,
  LeftContent,
  MediaIcon,
  MediaIconLink,
  MobileAppLinks,
  MobileLink,
  MobileSVG,
  MoreInfoContent,
  NeedHelpContent,
  PillSVG,
  RightContent,
  SocialMediaContent,
  SocialMediaIcons,
  StyledLink,
  StyledSection,
  SubsectionTitle,
} from './styles';

export const FooterV2 = ({ trackExternalLinkClick }: { trackExternalLinkClick: (arg: string) => void }) => {
  return (
    <StyledSection color="capsuleGreen00">
      <FlexContent>
        <LeftContent>
          <NeedHelpContent>
            <SubsectionTitle variant="h4">Need help?</SubsectionTitle>
            <Typography variant="body" marginBottom={'s3'}>
              Call or text us <DefaultPhoneNumber color={'capsuleGreen80'} />
            </Typography>
            <Typography variant="body">
              Email us{' '}
              <StyledLink color={'capsuleGreen80'} href={`mailto:${CAPSULE_HELP_EMAIL}`}>
                {CAPSULE_HELP_EMAIL}
              </StyledLink>
            </Typography>
          </NeedHelpContent>

          <AppButtonsContent>
            <SubsectionTitle variant="h4" small>
              Get the app
            </SubsectionTitle>
            <MobileAppLinks>
              <MobileLink
                href={external.appStore}
                aria-label="Download on the iOS App Store"
                onClick={() => {
                  trackExternalLinkClick(external.appStore);
                }}
              >
                <MobileSVG src={appStoreIcon} />
              </MobileLink>

              <MobileLink
                href={external.googlePlay}
                aria-label="Download on the Google Play Store"
                onClick={() => {
                  trackExternalLinkClick(external.googlePlay);
                }}
              >
                <MobileSVG src={googlePlayIcon} />
              </MobileLink>
            </MobileAppLinks>
          </AppButtonsContent>
        </LeftContent>
        <RightContent>
          <CompanyInfoContent>
            <SubsectionTitle variant="h4" marginBottom={'s5'}>
              Company info
            </SubsectionTitle>
            <MoreInfoContent>
              <Info>
                <LinkWithQuery to={about.route}>About us</LinkWithQuery>
              </Info>
              <Info>
                <a href={blog.route} target="_blank" rel="noopener noreferrer">
                  Blog
                </a>
              </Info>
              <Info>
                <a href={careers.route}>Careers</a>
              </Info>
              <Info>
                <LinkWithQuery to={doctors.route}>For doctors</LinkWithQuery>
              </Info>
              <Info>
                <a href={press.route} target="_blank" rel="noopener noreferrer">
                  Press
                </a>
              </Info>
            </MoreInfoContent>
          </CompanyInfoContent>

          <SocialMediaContent>
            <SubsectionTitle variant="h4" marginBottom={'s5'}>
              Social Media
            </SubsectionTitle>
            <SocialMediaIcons>
              <MediaIconLink href={external.facebook} aria-label="Go to Facebook page">
                <MediaIcon src={facebookIcon} />
              </MediaIconLink>
              <MediaIconLink href={external.instagram} aria-label="Go to Instagram page">
                <MediaIcon src={instagramIcon} />
              </MediaIconLink>
              <MediaIconLink href={external.twitter} aria-label="Go to Twitter page">
                <MediaIcon src={twitterIcon} />
              </MediaIconLink>
            </SocialMediaIcons>
          </SocialMediaContent>
          <PillSVG src={pillSection} />
        </RightContent>
      </FlexContent>
      <Copyright>
        <Typography variant="small" marginBottom={'s2'}>
          © {new Date().getFullYear()} Capsule Corporation
        </Typography>
        <div>
          <CopyrightLink to={getUrlPathWithPreservedQuery(termsAndConditions.route)}>Terms of Service</CopyrightLink>
          <CopyrightLink to={getUrlPathWithPreservedQuery(privacy.route)}>Privacy Policy</CopyrightLink>
          <CopyrightLink to={getUrlPathWithPreservedQuery(hipaa.route)}>HIPAA Policy</CopyrightLink>
        </div>
      </Copyright>
    </StyledSection>
  );
};
